import React, { useState, useEffect, useRef } from "react";
import { useDispatch } from "react-redux";
import {
  delete_Project,
  GET_PROJECT_SEC_DATA,
} from "../../../services/constants";
import axios from "axios";
import AreYousure from "../../share/card-layout/AreYousure";
import ProjectTable from "./project-table";
import { ZustandStore } from "../../../store/zustand-store";
import { ReactComponent as ComputerIcon } from "../../Assets/rank-tracking-assets/computer.svg";
import { ReactComponent as MobileIcon } from "../../Assets/rank-tracking-assets/mobile.svg";
import SwitchComponent from "../../share/components/switch.component";
import { useTranslation } from "react-i18next";
import useDebouncedFunction from "../../../helperJs/debounce";

const Projects = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();

  const [Device, setDevice] = useState("desktop");
  const [showDeleteAlert, setShowDeleteAlert] = useState({
    show: false,
    id: "",
  });

  const timeoutRef = useRef(null);
  const deviceRef = useRef(Device); // to keep latest device value

  const { emptyKeywordData, emptyAllLocData, project_section } = ZustandStore(
    (state) => state
  );

  const handleProjectSecData = async (signal) => {
    const email = localStorage.getItem("admin_mail");
    if (project_section.data?.length > 0) return;

    ZustandStore.setState((state) => ({
      project_section: {
        ...state.project_section,
        loading: true,
        error: false,
      },
    }));

    try {
      const response = await axios.get(GET_PROJECT_SEC_DATA(email, Device), {
        signal, // 👈 important for cancellation
      });

      ZustandStore.setState({
        project_section: {
          data: response.data?.data || [],
          error: false,
          loading: false,
        },
      });
    } catch (error) {
      // Only show error if it's NOT due to cancellation
      if (error.name !== "CanceledError") {
        ZustandStore.setState({
          project_section: {
            data: [],
            error: true,
            loading: false,
          },
        });
      }
    }
  };

  useEffect(() => {
    const email = localStorage.getItem("admin_mail");
    const controller = new AbortController();

    if (email) {
      timeoutRef.current = setTimeout(() => {
        handleProjectSecData(controller.signal);
      }, 1000);
    }

    return () => {
      clearTimeout(timeoutRef.current);
      controller.abort(); // ❌ cancels the previous request
    };
  }, [Device]);

  const deleteProject = () => {
    const id = showDeleteAlert?.id;
    axios
      .delete(delete_Project(id))
      .then(() => {
        sessionStorage.removeItem("LAST_PRPJECT_SELECTED");
        setShowDeleteAlert({ show: false, id: "" });
        dispatch({
          type: "USERALLPROJECTDETAILS",
          payload: [],
        });
        ZustandStore.setState({
          project_section: {
            data: [],
            error: false,
            loading: true,
          },
        });
        emptyKeywordData();
        emptyAllLocData();
        dispatch({ type: "WEBSITEURL", payload: null });
        dispatch({ type: "CURRENTLOCATIONCODE", payload: null });
        dispatch({ type: "CURRENTLOCATION", payload: null });
      })
      .finally(() => {
        setDevice(deviceRef.current);
      });
  };

  const handleProjectDelete = (res) => {
    if (res) {
      setShowDeleteAlert((pre) => ({
        ...pre,
        show: false,
      }));
      deleteProject();
    } else {
      setShowDeleteAlert({ show: false, id: "" });
    }
  };

  const debouncedToggleDevice = useDebouncedFunction(() => {
    ZustandStore.setState({
      project_section: {
        data: [],
        error: false,
        loading: false,
      },
    });
    const nextDevice = deviceRef.current === "mobile" ? "desktop" : "mobile";
    setDevice(nextDevice);
  }, 1000); // adjust delay as needed

  const handleChange = (event) => {
    ZustandStore.setState({
      project_section: {
        ...ZustandStore.getState().project_section,
        loading: true,
      },
    });

    // Update ref and debounce toggle
    deviceRef.current = Device;
    debouncedToggleDevice();
  };

  return (
    <main className="main-pd project-section">
      <h1 className="project-sec-heading">{t("projects.title")}</h1>
      <div className="rank-switch my-4">
        <span>
          <ComputerIcon
            className={
              Device === "mobile" ? "disable-switch" : "selected-switch"
            }
          />
        </span>
        <SwitchComponent
          checked={Device === "mobile"}
          onChange={(e) => handleChange(e)}
          className={Device === "mobile" ? "thumb-mobile" : "thumb-comp"}
        />
        <span>
          <MobileIcon
            className={
              Device === "mobile" ? "selected-switch" : "disable-switch"
            }
          />
        </span>
      </div>
      <ProjectTable {...{ setShowDeleteAlert }} />
      {showDeleteAlert?.show ? (
        <AreYousure
          callback={handleProjectDelete}
          title={t("projects.delete_alert")}
        />
      ) : null}
    </main>
  );
};

export default Projects;
